module.exports = __webpack_public_path__ + "static/media/4ODA9.c4a51702.jpg";